import axios from "axios";
import { baseUrl } from "../baseUrl";
import {
    errorHandlerMiddleWare,
    handleSessionExpired,
    isExpiredPayload,
    requestMiddleWare,
    responseMiddleWare,
} from "../httpInterSeptur/HttpInterSeptur";
import CryptoJS from "crypto-js";

function hashStringWithSecretKey(string, secretKey) {
    const hmac = CryptoJS.HmacSHA256(string, secretKey);
    const hash = hmac.toString(CryptoJS.enc.Base64);
    return hash;
}
const axiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 10000, // Set timeout to 10 seconds (adjust as needed)
    withCredentials: true,
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        console.log(config.data);
        const base64 = btoa(JSON.stringify(config.data));
        const checkSum = hashStringWithSecretKey(
            base64,
            "jbuyviycutxydrxyrxyddyxyrdx"
        );
        config.data = { base64, checkSum };

        const modifiedConfig = requestMiddleWare(config);
        console.log(modifiedConfig);

        return modifiedConfig;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for axiosInstance (used by axiosInstance calls)
axiosInstance.interceptors.response.use(
    (response) => {
        // Apply response middleware logic
        const modifiedResponse = responseMiddleWare(response);
        return modifiedResponse;
    },
    (error) => {
        // Handle response errors
        errorHandlerMiddleWare(error);
        return Promise.reject(error);
    }
);

// Intercept global axios responses for direct axios calls in Login.js (e.g. fetchInitialPackages)
// Returns the original response untouched so existing callers can extract response.data normally
axios.interceptors.response.use(
    (response) => {
        const data = response?.data;
        if (isExpiredPayload(data)) {
            handleSessionExpired();
        }
        return response;
    },
    (error) => {
        errorHandlerMiddleWare(error);
        return Promise.reject(error);
    }
);

export default axiosInstance;
